import { useMutation, useQueryClient } from '@tanstack/react-query'
import {
  updateIndeedFlexCompany,
  type UpdateIndeedFlexCompanyParams,
} from 'api/admin/indeedFlex/updateIndeedFlexCompany'
import { indeedFlexKeys } from './keys'

export const useUpdateIndeedFlexCompanyMutation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (params: UpdateIndeedFlexCompanyParams) =>
      updateIndeedFlexCompany(params),
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.companies(),
      })
      await queryClient.invalidateQueries({
        queryKey: indeedFlexKeys.clients(),
      })
    },
  })
}
